import React, { useState, lazy, Suspense } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { appLogOutHandler, appRedirect, getUserName, reloadPage } from 'Global/UserAccessToken';
import printScreenImg from "Common/img/SVG/PhoenixPrintScreenIcon.svg";
import helpImg from "Common/img/SVG/PhoenixHelpIcons.svg";
import userImg from "Common/img/SVG/PhoenixUserIcons.svg";
import { LogoutComponent } from 'Global/LogoutComponent';
import AppService from 'Global/AppService';
import { connect } from 'react-redux';
import NavSearch from './NavSearch';
import { getUserEmail } from 'Global/UserAccessToken'
import { logout } from 'Global/AuthService';
const UserPreferenceSettingComponent = lazy(() => import('UserManagement/components/UserPreferenceSettingComponent'));
import { SET_USER_PREFERENCE_DISPLAYED, SET_SHOW_USER_PREFERENCE_MODAL } from 'UserManagement/store/UserPreferenceSettingConstants';
import { ERROR_SAVE_USER_PREFERENCE_MODAL } from 'Home/store/HomePageConstants';
import ErrorComponent from 'Common/components/ErrorComponent';
import { getUserManualURL } from 'ECD/NGIApiUrls';
import LoaderComponent from 'Common/components/LoaderComponent';
import { ROLE_CHANNEL_PARTNER } from 'Common/constants/roles.constant';

const NavRightOptions = ({ dispatch, homePageData, userPrefData, basicSearchData, authData }) => {

    const [show, setShow] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const isUserPreferencesDisabled = authData?.authorizedAssignedRoles?.includes(ROLE_CHANNEL_PARTNER);

    let userName = getUserName();
    if (!userName) {
        reloadPage();
    }

    const handleClose = () => {
        appRedirect();
    }

    const onSelectUserPreference = () => {
        dispatch({ type: SET_SHOW_USER_PREFERENCE_MODAL, newState: { showUserPreferenceModal: true } });
    }

    const handleSavePreferenceErrorModalCloseEvent = () => {
        dispatch({ type: ERROR_SAVE_USER_PREFERENCE_MODAL, newState: { errorSaveUserPreferenceModal: false } });
    }

    const handleHelpClick = () => {
        const url = getUserManualURL().url;
        AppService.getData(url, (success, err) => {
            setShowLoader(false);
            if (success && success.result) {
                const win = window.open(success.result, '_blank');
                win.focus();
            } else {
                setErrorMsg('Unable to retrieve help manual.');
            }
        });
        setShowLoader(true);
    };

    return (
        <>
            <LogoutComponent show={show} handleClose={handleClose} />
            <ul data-testid="nav-bar-right-list" id="nav-right-menu" className="navbar-nav nav-justify-end" >
                <li className="nav-item nav-border-left nav-border-right">
                    <NavSearch />
                </li>
                {/* <li className="nav-item nav_min_width">
                    <a className="nav-link item-text nav-border-right">
                        <img src={printScreenImg} className="nav-icons" /> 
                        <div className="nav_headings">Print Screen</div>
                    </a>
                </li>
                <li className="nav-item nav_min_width">
                    <a className="nav-link item-text nav-border-right">
                        <img src={helpImg} className="nav-icons" /> 
                        <div className="nav_headings">Help</div>
                    </a>
                </li> */}
                <li className="nav_min_width">
                    <NavDropdown title={
                        <span className="nav-user-dropdown-title">
                            <span className="username nav_headings" title={userName}>{userName}</span>
                            <img src={userImg} className="user-icon" alt="User"></img>
                        </span>
                    } className="dropdown-padding" id="nav-dropdown">
                        <NavDropdown.Item eventKey="1" onClick={() => logout(() => setShow(true), basicSearchData)}>Log Out</NavDropdown.Item>
                        <NavDropdown.Item eventKey="2" onClick={() => handleHelpClick()}>Help</NavDropdown.Item>
                        <NavDropdown.Item eventKey="3" onClick={onSelectUserPreference} disabled={isUserPreferencesDisabled}>User Preferences Setting</NavDropdown.Item>
                        <NavDropdown.Item eventKey="4" disabled>Manage User Accounts</NavDropdown.Item>
                    </NavDropdown>
                </li>
            </ul>

            <ErrorComponent show={homePageData.errorSaveUserPreferenceModal} heading='error' message='Unable to save preference setting data due to technical error.' handleClose={() => handleSavePreferenceErrorModalCloseEvent()} />

            {userPrefData?.showUserPreferenceModal == true && <Suspense fallback={null}><UserPreferenceSettingComponent /></Suspense>}

            {!isUserPreferencesDisabled && homePageData?.userPreferenceExists == false && localStorage.getItem("isUserPreferencedDisplayedToUser") == null && <Suspense fallback={null}><UserPreferenceSettingComponent /></Suspense>}
            <LoaderComponent show={showLoader} message="Downloading" />
            <ErrorComponent show={!!errorMsg} heading="Error" message="Unable to retrieve help manual." handleClose={() => setErrorMsg('')} />
        </>
    )
}

function select(state) {
    return {
        homePageData: state.HomePageReducer,
        userPrefData: state.UserPreferenceSettingReducer,
        basicSearchData: state.BasicSearchReducer,
        authData: state.AuthorizationReducer
    };
}
export default connect(select)(NavRightOptions)
